import { useCurrentUser } from 'FrontRoyalAngular';
import { getActiveInstitution } from 'Users';
import { InstitutionId } from 'Institutions';

/*
    Mirrors User#isMiyaMiya, which is `active_institution?.id === InstitutionId.miya_miya`.

    The Angular getter carries a FIXME asking for this to move to AppBrandConfig. That is still the
    right end state; this only keeps the certificate branch working until then.
*/
export function useIsMiyaMiya() {
    const currentUser = useCurrentUser();
    return getActiveInstitution(currentUser)?.id === InstitutionId.miya_miya;
}
